module.exports = __webpack_public_path__ + "img/Character_Sucrose_Thumb.551b8e58.png";